import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { StorageService } from '@services/core/storage.service';

@Injectable({
    providedIn: 'root'
})

export class MicrosoftAuthService {
    private url: any;
    private url_back: any;
    public token: WritableSignal<string> = signal<string>('')
    public refreshToken: WritableSignal<string> = signal<string>('')
    public sessionToken: WritableSignal<string> = signal<string>('')

    storageService = inject(StorageService)

    constructor(
        private _http: HttpClient,
    ) {
        this.url = Global.url_api_auth
        this.url_back = Global.url_auth
    }

    getTokenAPI(): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + "get-token", { headers: headers });
    }

    getAccessToken(data: any): Observable<any> {
        let params = JSON.stringify({ code: data })
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + "authorize-token", params, { headers: headers });
    }

    decryptToken(): Observable<any> {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('x-refresh-token', this.refreshToken() || '');
        return this._http.get(this.url_back + "decrypt-token", { headers: headers });
    }

    refreshTokenAPI(): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
        let refresh_token = this.refreshToken()
        return this._http.get(this.url + "refresh-token/" + refresh_token, { headers: headers });
    }

    renewSessionToken(): Observable<any> {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('x-session-token', this.sessionToken() || '');
        return this._http.post(this.url_back + "renew-token", {}, { headers: headers });
    }

    logout(): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + "logout-session/" + this.token, { headers: headers });
    }

    getToken() {
        const token = this.storageService.getJsonValue("token")
        if (token) return token
    }

    getSessionToken() {
        const stored = this.storageService.getJsonValue("sessionToken")
        if (stored) {
            this.sessionToken.set(stored)
            return stored
        }
        return null
    }

    setSessionToken(token: string) {
        this.sessionToken.set(token)
        this.storageService.setJsonValue("sessionToken", token)
    }

    clearSesion() {
        this.sessionToken.set('')
        this.storageService.clearStorage()
    }
}

